import styled from 'styled-components';
import get from 'lodash/get';
import createLinkRel from '~/helpers/createLinkRel';
import TeaserTileContent from './partials/TeaserTileContent';
import UrlContext from '~/helpers/UrlContext';
import { Tile } from '../../atoms/Tile';
import useToggle from '~/hooks/useToggle';
import { useContext } from 'react';

const StyledTile = styled(Tile)`
  height: 100%;

  &:not(:hover) img {
    -webkit-animation: descale-in-center 0.5s
      cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    animation: descale-in-center 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }

  &:hover img {
    -webkit-animation: scale-in-center 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      both;
    animation: scale-in-center 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }

  /**
 * ----------------------------------------
 * animation scale-in-center
 * ----------------------------------------
 */
  @-webkit-keyframes scale-in-center {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
    100% {
      -webkit-transform: scale(1.03);
      transform: scale(1.03);
      opacity: 1;
    }
  }
  @keyframes scale-in-center {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
    100% {
      -webkit-transform: scale(1.03);
      transform: scale(1.03);
    }
  }

  /**
 * ----------------------------------------
 * animation descale-in-center
 * ----------------------------------------
 */
  @-webkit-keyframes descale-in-center {
    0% {
      -webkit-transform: scale(1.03);
      transform: scale(1.03);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  @keyframes descale-in-center {
    0% {
      -webkit-transform: scale(1.03);
      transform: scale(1.03);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
`;

const Link = styled.a`
  text-decoration: none;
`;

/**
 * @param {TeaserTileProps} props
 * @returns {React.ReactElement} The rendered component
 */
const TeaserTile = ({
  mainLink,
  headline,
  text,
  textV2,
  linkList,
  type = 'MEDIUM',
  image,
  parentContainerType,
}) => {
  const [isHovered, toggleIsHovered] = useToggle(false);
  const rel = createLinkRel(get(mainLink, 'target', '_self'));
  const createUrl = useContext(UrlContext);

  return (
    <StyledTile
      handleMouseEnter={toggleIsHovered}
      handleMouseLeave={toggleIsHovered}
      isClickable={!!mainLink}
    >
      {mainLink ? (
        <Link
          href={createUrl(mainLink.url)}
          title={mainLink.title !== '' ? mainLink.title : headline}
          target={mainLink.target}
          rel={rel}
          data-id="teaser-tile-link"
        >
          <TeaserTileContent
            isHovered={isHovered}
            image={image}
            type={type}
            linkList={linkList}
            headline={headline}
            text={text}
            textV2={textV2}
            readmoreText={mainLink.text}
            isClickable
            parentContainerType={parentContainerType}
          />
        </Link>
      ) : (
        <TeaserTileContent
          image={image}
          type={type}
          linkList={linkList}
          headline={headline}
          text={text}
          textV2={textV2}
          parentContainerType={parentContainerType}
        />
      )}
    </StyledTile>
  );
};

export default TeaserTile;
